import { ICoords, INearbyStation, IStation } from './types'

const EARTH_RADIUS = 6371000

const toRadians = (degrees: number) => (degrees * Math.PI) / 180

/** Great-circle distance in metres — haversine, more than enough for 400 m. */
export const distanceMeters = (a: ICoords, b: ICoords) => {
  const dLat = toRadians(b.lat - a.lat)
  const dLng = toRadians(b.lng - a.lng)
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(a.lat)) *
      Math.cos(toRadians(b.lat)) *
      Math.sin(dLng / 2) ** 2
  return 2 * EARTH_RADIUS * Math.asin(Math.sqrt(h))
}

/**
 * The closest station within `radius` metres of `coords`. Stations the
 * backend sent without a position cannot match.
 */
export const findNearby = (
  stations: IStation[],
  coords: ICoords,
  radius: number
): INearbyStation | undefined => {
  let best: INearbyStation | undefined
  for (const station of stations) {
    if (station.lat === undefined || station.lng === undefined) continue
    const distance = distanceMeters(coords, {
      lat: station.lat,
      lng: station.lng,
    })
    if (distance <= radius && (!best || distance < best.distance)) {
      best = { station, distance }
    }
  }
  return best
}

/** `173.4` -> `173 м`. */
export const formatDistance = (meters: number) => `${Math.round(meters)} м`
